/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as CadastroRouteImport } from './routes/cadastro'
import { Route as EntrarRouteImport } from './routes/entrar'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedCategoriasRouteImport } from './routes/_authenticated/categorias'
import { Route as AuthenticatedConfiguracoesRouteImport } from './routes/_authenticated/configuracoes'
import { Route as AuthenticatedImportarRouteImport } from './routes/_authenticated/importar'
import { Route as AuthenticatedInstituicoesRouteImport } from './routes/_authenticated/instituicoes'
import { Route as AuthenticatedPerfilRouteImport } from './routes/_authenticated/perfil'
import { Route as AuthenticatedProjecoesRouteImport } from './routes/_authenticated/projecoes'
import { Route as AuthenticatedTransacoesRouteImport } from './routes/_authenticated/transacoes'
import { Route as AuthenticatedCartoesCardIdRouteImport } from './routes/_authenticated/cartoes.$cardId'
import { Route as AuthenticatedImportarImportIdRouteImport } from './routes/_authenticated/importar_.$importId'
import { Route as AuthenticatedTransacoesAvulsosRouteImport } from './routes/_authenticated/transacoes_.avulsos'
import { Route as AuthenticatedTransacoesFixosRouteImport } from './routes/_authenticated/transacoes_.fixos'
import { Route as AuthenticatedTransacoesParceladosRouteImport } from './routes/_authenticated/transacoes_.parcelados'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const CadastroRoute = CadastroRouteImport.update({
  id: '/cadastro',
  path: '/cadastro',
  getParentRoute: () => rootRouteImport,
} as any)
const EntrarRoute = EntrarRouteImport.update({
  id: '/entrar',
  path: '/entrar',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCategoriasRoute = AuthenticatedCategoriasRouteImport.update({
  id: '/categorias',
  path: '/categorias',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedConfiguracoesRoute =
  AuthenticatedConfiguracoesRouteImport.update({
    id: '/configuracoes',
    path: '/configuracoes',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedImportarRoute = AuthenticatedImportarRouteImport.update({
  id: '/importar',
  path: '/importar',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedInstituicoesRoute =
  AuthenticatedInstituicoesRouteImport.update({
    id: '/instituicoes',
    path: '/instituicoes',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPerfilRoute = AuthenticatedPerfilRouteImport.update({
  id: '/perfil',
  path: '/perfil',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProjecoesRoute = AuthenticatedProjecoesRouteImport.update({
  id: '/projecoes',
  path: '/projecoes',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTransacoesRoute = AuthenticatedTransacoesRouteImport.update({
  id: '/transacoes',
  path: '/transacoes',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCartoesCardIdRoute =
  AuthenticatedCartoesCardIdRouteImport.update({
    id: '/cartoes/$cardId',
    path: '/cartoes/$cardId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedImportarImportIdRoute =
  AuthenticatedImportarImportIdRouteImport.update({
    id: '/importar_/$importId',
    path: '/importar/$importId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTransacoesAvulsosRoute =
  AuthenticatedTransacoesAvulsosRouteImport.update({
    id: '/transacoes_/avulsos',
    path: '/transacoes/avulsos',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTransacoesFixosRoute =
  AuthenticatedTransacoesFixosRouteImport.update({
    id: '/transacoes_/fixos',
    path: '/transacoes/fixos',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTransacoesParceladosRoute =
  AuthenticatedTransacoesParceladosRouteImport.update({
    id: '/transacoes_/parcelados',
    path: '/transacoes/parcelados',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/cadastro': typeof CadastroRoute
  '/entrar': typeof EntrarRoute
  '/categorias': typeof AuthenticatedCategoriasRoute
  '/configuracoes': typeof AuthenticatedConfiguracoesRoute
  '/importar': typeof AuthenticatedImportarRoute
  '/instituicoes': typeof AuthenticatedInstituicoesRoute
  '/perfil': typeof AuthenticatedPerfilRoute
  '/projecoes': typeof AuthenticatedProjecoesRoute
  '/transacoes': typeof AuthenticatedTransacoesRoute
  '/cartoes/$cardId': typeof AuthenticatedCartoesCardIdRoute
  '/importar/$importId': typeof AuthenticatedImportarImportIdRoute
  '/transacoes/avulsos': typeof AuthenticatedTransacoesAvulsosRoute
  '/transacoes/fixos': typeof AuthenticatedTransacoesFixosRoute
  '/transacoes/parcelados': typeof AuthenticatedTransacoesParceladosRoute
}
export interface FileRoutesByTo {
  '/cadastro': typeof CadastroRoute
  '/entrar': typeof EntrarRoute
  '/categorias': typeof AuthenticatedCategoriasRoute
  '/configuracoes': typeof AuthenticatedConfiguracoesRoute
  '/importar': typeof AuthenticatedImportarRoute
  '/instituicoes': typeof AuthenticatedInstituicoesRoute
  '/perfil': typeof AuthenticatedPerfilRoute
  '/projecoes': typeof AuthenticatedProjecoesRoute
  '/transacoes': typeof AuthenticatedTransacoesRoute
  '/': typeof AuthenticatedIndexRoute
  '/cartoes/$cardId': typeof AuthenticatedCartoesCardIdRoute
  '/importar/$importId': typeof AuthenticatedImportarImportIdRoute
  '/transacoes/avulsos': typeof AuthenticatedTransacoesAvulsosRoute
  '/transacoes/fixos': typeof AuthenticatedTransacoesFixosRoute
  '/transacoes/parcelados': typeof AuthenticatedTransacoesParceladosRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/cadastro': typeof CadastroRoute
  '/entrar': typeof EntrarRoute
  '/_authenticated/categorias': typeof AuthenticatedCategoriasRoute
  '/_authenticated/configuracoes': typeof AuthenticatedConfiguracoesRoute
  '/_authenticated/importar': typeof AuthenticatedImportarRoute
  '/_authenticated/instituicoes': typeof AuthenticatedInstituicoesRoute
  '/_authenticated/perfil': typeof AuthenticatedPerfilRoute
  '/_authenticated/projecoes': typeof AuthenticatedProjecoesRoute
  '/_authenticated/transacoes': typeof AuthenticatedTransacoesRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/cartoes/$cardId': typeof AuthenticatedCartoesCardIdRoute
  '/_authenticated/importar_/$importId': typeof AuthenticatedImportarImportIdRoute
  '/_authenticated/transacoes_/avulsos': typeof AuthenticatedTransacoesAvulsosRoute
  '/_authenticated/transacoes_/fixos': typeof AuthenticatedTransacoesFixosRoute
  '/_authenticated/transacoes_/parcelados': typeof AuthenticatedTransacoesParceladosRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/cadastro'
    | '/entrar'
    | '/categorias'
    | '/configuracoes'
    | '/importar'
    | '/instituicoes'
    | '/perfil'
    | '/projecoes'
    | '/transacoes'
    | '/cartoes/$cardId'
    | '/importar/$importId'
    | '/transacoes/avulsos'
    | '/transacoes/fixos'
    | '/transacoes/parcelados'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/cadastro'
    | '/entrar'
    | '/categorias'
    | '/configuracoes'
    | '/importar'
    | '/instituicoes'
    | '/perfil'
    | '/projecoes'
    | '/transacoes'
    | '/'
    | '/cartoes/$cardId'
    | '/importar/$importId'
    | '/transacoes/avulsos'
    | '/transacoes/fixos'
    | '/transacoes/parcelados'
  id:
    | '__root__'
    | '/_authenticated'
    | '/cadastro'
    | '/entrar'
    | '/_authenticated/categorias'
    | '/_authenticated/configuracoes'
    | '/_authenticated/importar'
    | '/_authenticated/instituicoes'
    | '/_authenticated/perfil'
    | '/_authenticated/projecoes'
    | '/_authenticated/transacoes'
    | '/_authenticated/'
    | '/_authenticated/cartoes/$cardId'
    | '/_authenticated/importar_/$importId'
    | '/_authenticated/transacoes_/avulsos'
    | '/_authenticated/transacoes_/fixos'
    | '/_authenticated/transacoes_/parcelados'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  CadastroRoute: typeof CadastroRoute
  EntrarRoute: typeof EntrarRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cadastro': {
      id: '/cadastro'
      path: '/cadastro'
      fullPath: '/cadastro'
      preLoaderRoute: typeof CadastroRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/entrar': {
      id: '/entrar'
      path: '/entrar'
      fullPath: '/entrar'
      preLoaderRoute: typeof EntrarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/categorias': {
      id: '/_authenticated/categorias'
      path: '/categorias'
      fullPath: '/categorias'
      preLoaderRoute: typeof AuthenticatedCategoriasRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/configuracoes': {
      id: '/_authenticated/configuracoes'
      path: '/configuracoes'
      fullPath: '/configuracoes'
      preLoaderRoute: typeof AuthenticatedConfiguracoesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/importar': {
      id: '/_authenticated/importar'
      path: '/importar'
      fullPath: '/importar'
      preLoaderRoute: typeof AuthenticatedImportarRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/instituicoes': {
      id: '/_authenticated/instituicoes'
      path: '/instituicoes'
      fullPath: '/instituicoes'
      preLoaderRoute: typeof AuthenticatedInstituicoesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/perfil': {
      id: '/_authenticated/perfil'
      path: '/perfil'
      fullPath: '/perfil'
      preLoaderRoute: typeof AuthenticatedPerfilRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projecoes': {
      id: '/_authenticated/projecoes'
      path: '/projecoes'
      fullPath: '/projecoes'
      preLoaderRoute: typeof AuthenticatedProjecoesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/transacoes': {
      id: '/_authenticated/transacoes'
      path: '/transacoes'
      fullPath: '/transacoes'
      preLoaderRoute: typeof AuthenticatedTransacoesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/cartoes/$cardId': {
      id: '/_authenticated/cartoes/$cardId'
      path: '/cartoes/$cardId'
      fullPath: '/cartoes/$cardId'
      preLoaderRoute: typeof AuthenticatedCartoesCardIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/importar_/$importId': {
      id: '/_authenticated/importar_/$importId'
      path: '/importar/$importId'
      fullPath: '/importar/$importId'
      preLoaderRoute: typeof AuthenticatedImportarImportIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/transacoes_/avulsos': {
      id: '/_authenticated/transacoes_/avulsos'
      path: '/transacoes/avulsos'
      fullPath: '/transacoes/avulsos'
      preLoaderRoute: typeof AuthenticatedTransacoesAvulsosRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/transacoes_/fixos': {
      id: '/_authenticated/transacoes_/fixos'
      path: '/transacoes/fixos'
      fullPath: '/transacoes/fixos'
      preLoaderRoute: typeof AuthenticatedTransacoesFixosRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/transacoes_/parcelados': {
      id: '/_authenticated/transacoes_/parcelados'
      path: '/transacoes/parcelados'
      fullPath: '/transacoes/parcelados'
      preLoaderRoute: typeof AuthenticatedTransacoesParceladosRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedCategoriasRoute: typeof AuthenticatedCategoriasRoute
  AuthenticatedConfiguracoesRoute: typeof AuthenticatedConfiguracoesRoute
  AuthenticatedImportarRoute: typeof AuthenticatedImportarRoute
  AuthenticatedInstituicoesRoute: typeof AuthenticatedInstituicoesRoute
  AuthenticatedPerfilRoute: typeof AuthenticatedPerfilRoute
  AuthenticatedProjecoesRoute: typeof AuthenticatedProjecoesRoute
  AuthenticatedTransacoesRoute: typeof AuthenticatedTransacoesRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedCartoesCardIdRoute: typeof AuthenticatedCartoesCardIdRoute
  AuthenticatedImportarImportIdRoute: typeof AuthenticatedImportarImportIdRoute
  AuthenticatedTransacoesAvulsosRoute: typeof AuthenticatedTransacoesAvulsosRoute
  AuthenticatedTransacoesFixosRoute: typeof AuthenticatedTransacoesFixosRoute
  AuthenticatedTransacoesParceladosRoute: typeof AuthenticatedTransacoesParceladosRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedCategoriasRoute: AuthenticatedCategoriasRoute,
  AuthenticatedConfiguracoesRoute: AuthenticatedConfiguracoesRoute,
  AuthenticatedImportarRoute: AuthenticatedImportarRoute,
  AuthenticatedInstituicoesRoute: AuthenticatedInstituicoesRoute,
  AuthenticatedPerfilRoute: AuthenticatedPerfilRoute,
  AuthenticatedProjecoesRoute: AuthenticatedProjecoesRoute,
  AuthenticatedTransacoesRoute: AuthenticatedTransacoesRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedCartoesCardIdRoute: AuthenticatedCartoesCardIdRoute,
  AuthenticatedImportarImportIdRoute: AuthenticatedImportarImportIdRoute,
  AuthenticatedTransacoesAvulsosRoute: AuthenticatedTransacoesAvulsosRoute,
  AuthenticatedTransacoesFixosRoute: AuthenticatedTransacoesFixosRoute,
  AuthenticatedTransacoesParceladosRoute:
    AuthenticatedTransacoesParceladosRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  CadastroRoute: CadastroRoute,
  EntrarRoute: EntrarRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
